import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
export default function PageHero() {
  return <section className="relative w-full bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 py-20 md:py-32 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/pest_texture_pattern.png')] bg-repeat"></div>
      </div>

      {/* Content Container */}
      <div className="relative z-10 container mx-auto px-4 md:px-6">
        <div className="max-w-3xl">
          {/* Main Heading */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Professional Termite Treatment & Prevention
          </h1>

          {/* Subheading */}
          <p className="text-lg md:text-xl text-slate-200 mb-8 leading-relaxed">
            Protect your home from termite damage with our comprehensive treatment solutions. Peace River Pest Control provides expert termite inspections, treatments, and prevention strategies throughout Southwest Florida.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/ContactPage">
              <Button size="lg" className="w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-white font-semibold">
                Schedule Free Inspection
              </Button>
            </Link>
            <a href="tel:941-888-0485">
              <Button size="lg" variant="outline" className="w-full sm:w-auto border-white text-white hover:bg-white hover:text-slate-900 font-semibold">
                Call Now: 941-888-0485
              </Button>
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="mt-12 flex flex-wrap gap-6 text-slate-300 text-sm">
            <div className="flex items-center gap-2">
              <span className="inline-block w-5 h-5 bg-orange-500 rounded-full"></span>
              Licensed & Insured
            </div>
            <div className="flex items-center gap-2">
              <span className="inline-block w-5 h-5 bg-orange-500 rounded-full"></span>
              24/7 Emergency Service
            </div>
            <div className="flex items-center gap-2">
              <span className="inline-block w-5 h-5 bg-orange-500 rounded-full"></span>
              Satisfaction Guaranteed
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Wave Decoration */}
      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-white to-transparent opacity-5"></div>
    </section>;
}